// src/pages/Legal.js
// =========================================================================
// CONDICIONES Y CONTRATOS: los textos legales que la clínica tiene con
// Klyndu, quién los aceptó y cuándo. Cualquier persona del personal los lee.
// =========================================================================
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { Modal, Spinner } from '../components/common/ui';
import TextoLegal from '../components/legal/TextoLegal';

export default function Legal() {
    const [estado, setEstado] = useState(null);
    const [error, setError] = useState('');
    const [abierto, setAbierto] = useState(null);

    useEffect(() => {
        api.get('/legal').then(setEstado).catch((e) => setError(e.message || 'No se pudieron cargar los documentos.'));
    }, []);

    const fecha = (f) => new Date(f).toLocaleString('es-ES', { dateStyle: 'long', timeStyle: 'short' });

    return (
        <div className="max-w-4xl mx-auto p-4 md:p-8 space-y-6">
            <div>
                <h1 className="text-2xl font-black text-slate-900 tracking-tight">Condiciones y contratos</h1>
                <p className="text-sm font-semibold text-slate-500">Los documentos que regulan el servicio de Klyndu para tu clínica.</p>
            </div>

            {error && <p className="text-sm font-bold text-rose-700">{error}</p>}
            {!estado && !error && <div className="flex justify-center py-10"><Spinner /></div>}

            {estado && (
                <div className="space-y-3">
                    {estado.documentos.map(d => (
                        <div key={d.id} className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 p-5 bg-white border border-slate-200 rounded-2xl">
                            <div>
                                <p className="text-sm font-black text-slate-900">{d.titulo}</p>
                                <p className="text-xs font-semibold text-slate-500">
                                    {d.aceptado
                                        ? `Versión ${d.version}, aceptada por ${d.aceptado.nombre || 'la clínica'} el ${fecha(d.aceptado.fecha)}.`
                                        : d.obligatorio
                                            ? `Versión ${d.version}, pendiente de aceptar.`
                                            : `Versión ${d.version}. Se acepta en el asistente de VeriFactu (Facturación).`}
                                </p>
                            </div>
                            <button onClick={() => setAbierto(d)} className="px-4 py-2 text-sm font-bold text-slate-700 bg-slate-100 hover:bg-slate-200 rounded-xl shrink-0">Leer</button>
                        </div>
                    ))}
                </div>
            )}

            <Modal open={!!abierto} onClose={() => setAbierto(null)} titulo={abierto?.titulo} size="lg">
                {abierto && <TextoLegal id={abierto.id} />}
            </Modal>
        </div>
    );
}
